import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, SingleCollectionDialogueHandler } from './types';
import SingleCollectionDialogueContext from './SingleCollectionContext';

const { ConfirmationDialogue } = vp;

type SingleCollectionDialogueProps = {
  handleDialogue: DialogueHandler<SingleCollectionDialogueHandler>;
};

type FC = FunctionComponent<SingleCollectionDialogueProps>;

const SingleCollectionDialogue: FC = ({ handleDialogue }: SingleCollectionDialogueProps) => {
  const { showSingleCollectionErrorAlert, singleCollectionError, showSingleCollectionConfirmAlert } = useContext(
    SingleCollectionDialogueContext,
  );

  return useMemo(
    () => (
      <div>
        {/* Single Collection Error */}
        <ConfirmationDialogue
          isVisible={showSingleCollectionErrorAlert}
          title="Error! The payment was not completed."
          status="error"
          subTitle={`${singleCollectionError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />

        {/* Single Collection Confirm */}
        <ConfirmationDialogue
          isVisible={showSingleCollectionConfirmAlert}
          title="Submit Collection?"
          status="alert"
          subTitle="Once collection is submitted, your transaction will begin processing. Please ensure all details are accurate before submission."
          confirm={{
            label: 'Submit Collection',
            action: () => handleDialogue({ type: 'confirm', state: 'confirm' }),
          }}
          cancel={{
            label: 'Go Back',
            action: () => handleDialogue({ type: 'confirm', state: 'cancel' }),
          }}
        />
      </div>
    ),
    [showSingleCollectionErrorAlert, singleCollectionError, showSingleCollectionConfirmAlert],
  );
};

export default SingleCollectionDialogue;
